import {createContext} from "react";
import {BlurMap} from "../types/hygiena-types";

/**
 * The Blur Map is a hashmap of "blur" image style urls to their respective
 * plaiceHolder generated images, that can be used for Next.js image placeholders.
 */
export const BlurMapContext = createContext({} as BlurMap);